import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJImage from '../../../../common/components/FJImage/FJImage';
import FJTextWithEllipsisParent from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisParent';
import FJConfig from '../../../../config/FJConfig';
import FJCheckIcon from '../../../../assets/svg/check-white.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJConstant from '../../../../constants/FJConstant';
import FJFileHandleUtil from '../../../../util/FJFileHandleUtil';

import styles from './FJCategoryOptionCard.module.less';

const FJCategoryOptionCard = ({ category, isSelected, onClick }) => {
    const [isShow, setIsShow] = useState(false);
    const galleryRef = useRef(null);
    const galleryTimer = useRef(null);
    const [loadStatus, setLoadStatus] = useState(FJConstant.DEFAULT);

    const handleMouseEnter = e => {
        clearTimeout(galleryTimer.current);
        galleryRef.current && (galleryRef.current.style.display = 'block');
        _fitInView(e.currentTarget.getBoundingClientRect());
        galleryTimer.current = setTimeout(() => {
            setIsShow(true);
            clearTimeout(galleryTimer.current);
        }, 300);
    };

    const handleMouseLeave = () => {
        clearTimeout(galleryTimer.current);
        setIsShow(false);
        galleryTimer.current = setTimeout(() => {
            galleryRef.current && (galleryRef.current.style.display = 'none');
            clearTimeout(galleryTimer.current);
        }, 300);
    };

    const _fitInView = rect => {
        if (!galleryRef.current) return;

        const gallery = galleryRef.current;
        const windowRect = {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight,
        };

        const galleryRect = gallery.getBoundingClientRect();

        // 获取画廊的尺寸
        const galleryWidth = galleryRect.width; // min-width from CSS
        const margin = 16; // 边距

        // 获取触发元素的边界
        const triggerRect = rect;
        const triggerCenterX = triggerRect.left + triggerRect.width / 2;

        let finalLeft = triggerRect.left + triggerRect.width + margin; // 默认右侧
        let finalTop = triggerRect.top;

        // 1. 尝试放在右侧
        if (finalLeft + galleryWidth > windowRect.width) {
            // 2. 右侧放不下，尝试放在左侧
            finalLeft = triggerRect.left - galleryWidth - margin;

            if (finalLeft < windowRect.left) {
                // 3. 左侧也放不下，尝试放在底部
                finalLeft = triggerCenterX - galleryWidth / 2;
                finalTop = triggerRect.bottom + margin;
            }
        }

        // 应用最终位置
        gallery.style.left = `${finalLeft}px`;
        gallery.style.top = `${finalTop}px`;
        gallery.style.right = 'auto';
        gallery.style.bottom = 'auto';
    };

    useEffect(() => {
        const handleScroll = () => {
            galleryRef.current && (galleryRef.current.style.display = 'none');
            setIsShow(false);
            clearTimeout(galleryTimer.current);
        };
        document.getElementById('headshot_stepper_scroller')?.addEventListener('scroll', handleScroll);
        return () => {
            document.getElementById('headshot_stepper_scroller')?.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div
            className={classNames(styles.option_card, {
                [styles.active]: isSelected,
            })}
            onClick={() => onClick(category)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <div
                className={classNames(styles.gallery_box, {
                    [styles.show]: isShow,
                })}
                ref={galleryRef}
            >
                <div className={styles.gallery_inner}>
                    <FJImage
                        imgSrc={FJFileHandleUtil.getImageUrlWithFormat(
                            `${FJConfig.headshotImagePath}category/${category.key}_previews.png?v=${FJConfig.version}`,
                        )}
                        imgClassName={styles.gallery_image}
                        boxClassName={styles.gallery_image_box}
                        isShowLoading
                    />
                </div>
            </div>
            <FJHoverBoardGradation
                className={styles.hover_board_box}
                active={isSelected}
                borderRadius={12}
                isShowInBorder
            >
                <>
                    <div className={styles.aspect_ratio_box}>
                        <FJImage
                            imgSrc={FJFileHandleUtil.getImageUrlWithFormat(
                                `${FJConfig.headshotImagePath}${category.imageUrl}?v=${FJConfig.version}`,
                            )}
                            imgClassName={styles.option_image}
                            boxClassName={styles.option_image_box}
                            loadCallback={setLoadStatus}
                            onRefresh={() => onClick(category)}
                            isShowLoading
                        />
                    </div>

                    <div
                        className={classNames(styles.option_content, {
                            [styles.error]: loadStatus === FJConstant.ERROR,
                        })}
                    >
                        <FJTextWithEllipsisParent className={styles.option_title} text={FJLocalStore._(category.key)} />
                    </div>
                </>
            </FJHoverBoardGradation>
            {isSelected && (
                <div className={classNames(styles.selected_icon)}>
                    <FJCheckIcon fill='currentColor' />
                </div>
            )}
        </div>
    );
};

FJCategoryOptionCard.propTypes = {
    // 单个卡片模式
    category: PropTypes.shape({
        key: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired,
    }),
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
    imagePath: PropTypes.string,
    version: PropTypes.string,
    // 画廊模式
    active: PropTypes.bool,
    closeModal: PropTypes.func,
    categories: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            imageUrl: PropTypes.string.isRequired,
        }),
    ),
    onCategorySelect: PropTypes.func,
    position: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    // 模式选择
    mode: PropTypes.oneOf(['card', 'gallery']),
};

export default FJCategoryOptionCard;
